// 按需加载Cubeui
import Vue from 'vue'
let that = new Vue();
// By default we import all the components.
// Only reserve the components on demand and remove the rest.
// Style is always required.
import {
  /* eslint-disable no-unused-vars */
  Style,
  // basic
  Button,
  Loading,
  Tip,
  Toolbar,
  TabBar,
  TabPanels,
  // form
  Checkbox,
  CheckboxGroup,
  Checker,
  Radio,
  RadioGroup,
  Input,
  Textarea,
  Select,
  Switch,
  Rate,
  Validator,
  Upload,
  Form,
  // popup
  Popup,
  Toast,
  Picker,
  CascadePicker,
  DatePicker,
  TimePicker,
  SegmentPicker,
  Dialog,
  ActionSheet,
  Drawer,
  ImagePreview,
  // scroll
  Scroll,
  Slide,
  IndexList,
  Swipe,
  Sticky,
  ScrollNav,
  ScrollNavBar,
  RecycleList
} from 'cube-ui'

export default () => {
    let eles = [
        Button,
        Loading,
        Tip,
        Toolbar,
        TabBar,
        TabPanels,
        // form
        Checkbox,
        CheckboxGroup,
        Checker,
        Radio,
        RadioGroup,
        Input,
        Textarea,
        Select,
        Switch,
        Rate,
        Validator,
        Upload,
        Form,
        // popup
        Popup,
        Toast,
        Picker,
        CascadePicker,
        DatePicker,
        TimePicker,
        SegmentPicker,
        Dialog,
        ActionSheet,
        Drawer,
        ImagePreview,
        // scroll
        Scroll,
        Slide,
        IndexList,
        Swipe,
        Sticky,
        ScrollNav,
        ScrollNavBar,
        RecycleList
    ];
    // 注册
    eles.forEach((item) => {
        Vue.use(item);
    });
    Vue.prototype.$toast = (txt, Etxt) => { 
      let langague = localStorage.getItem("current_lang");
      let tip = (langague == "en-us" && Etxt) ? Etxt : txt
      that.$createToast({
            txt: tip,
            type: 'txt'
          }).show();
      }
}
